/** The "{n} of {m}" numerator/denominator line + "Next: {title}" (or "All done"). */
import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import type { ActivationProjection } from '@modules/shared-types';
import { LAUNCH_ACTIVATION_TEST_IDS } from '../testIds';

export const ActivationProgress: React.FC<{ projection: ActivationProjection }> = ({ projection }) => {
  const percent = projection.totalCount === 0 ? 0 : Math.min(100, Math.round((projection.earnedCount / projection.totalCount) * 100));
  return (
    <Box sx={{ mb: 2 }}>
      <LinearProgress variant="determinate" value={percent} sx={{ height: 6, borderRadius: 1 }} aria-label="Launch progress" />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5, gap: 2 }}>
        <Typography data-testid={LAUNCH_ACTIVATION_TEST_IDS.progress} variant="body2" color="text.primary">
          {projection.earnedCount} of {projection.totalCount}
        </Typography>
        <Typography data-testid={LAUNCH_ACTIVATION_TEST_IDS.next} variant="body2" color="text.secondary">
          {projection.next ? `Next: ${projection.next.title}` : 'All done'}
        </Typography>
      </Box>
    </Box>
  );
};
